import { DSLightColors, DSDarkColors } from './colors';
import { DSLightSemantic, DSDarkSemantic } from './semantic';
import { DS_SPACINGS } from './spacings';
import { DS_SHADOWS } from './shadows';
import { DS_TOKENS } from './tokens';
import { DS_RADIUSES } from './radiuses';
import { DS_FONTS } from './fonts';
import type { DefaultTheme } from 'styled-components/macro';

export { GlobalStyles } from './global-styles';
// TODO: Удалить экспорт снизу,
// когда избавимся от импорта DS_COLORS во многих файлах
export { DSLightColors as DS_COLORS } from './colors';

export {
  DSLightColors,
  DSDarkColors,
  DSLightSemantic,
  DSDarkSemantic,
  DS_SPACINGS,
  DS_SHADOWS,
  DS_TOKENS,
  DS_RADIUSES,
  DS_FONTS,
};
export type { DSSemantic } from './semantic';
export type {
  DSColorValues,
  DSColorsKeys,
  DSColorsShade,
  DSScaledColors,
} from './colors';

export const theme: DefaultTheme = {
  colors: DSLightColors,
  semantic: DSLightSemantic,
  spacings: DS_SPACINGS,
  shadows: DS_SHADOWS,
  tokens: DS_TOKENS,
  radiuses: DS_RADIUSES,
  fonts: DS_FONTS,
  mode: 'light',
};
